<template>
  <div class="article">
    <div class="header">
      <div
        @click="clickBreadcrumbItem('home')"
        class="header-item"
        :class="{active: true}"
      >首页 >&#8194;</div>
      <div
        v-for="(item, index) in breadcrumbList"
        :key="index"
        @click="clickBreadcrumbItem('articleList', item, index)"
        class="header-item"
        :class="{active: index !== breadcrumbList.length - 1}"
      >
        <span>
          {{item.name}}
          <span v-if="index !== breadcrumbList.length - 1">>&#8194;</span>
        </span>
      </div>
    </div>
    <div class="content">
      <BroadsideMenu :dataList="menuList" v-if="menuList.length > 0"></BroadsideMenu>
      <div :class="{'active-right': menuList.length === 0}" class="right">
        <ArticleList
          :dataList="articleList"
          v-if="$route.query.type === 'list' && articleList.length !== 0 && !isLoading"
        ></ArticleList>
        <Article
          :articleDetail="articleDetail"
          v-else-if="$route.query.type === 'article' && articleDetail && !isLoading"
        ></Article>
        <div
          v-if="articleDetail === null && articleList.length === 0 && isLoading"
          class="content-text"
        >文章加载中...</div>
        <div
          v-if="articleDetail === null && articleList.length === 0 && !isLoading"
          class="content-text"
        >暂无数据</div>
        <div class="footer" v-if="$route.query.type === 'list' && articleList.length > 0">
          <Page
            :total="articleTotal"
            :page-size="10"
            :current.sync="articleCurrent"
            show-total
            @on-change="changePage"
          ></Page>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BroadsideMenu from "../components/Menu/BroadsideMenu";
import ArticleList from "../components/ArticleList/ArticleList-3.vue";
import Article from "../components/Article.vue";
let dayjs = require("dayjs");

export default {
  data() {
    return {
      menuList: [],
      articleList: [],
      articleDetail: null,
      articleTotal: 0,
      articleCurrent: 1,
      isLoading: false
    };
  },
  computed: {
    breadcrumbList() {
      if (this.$store.state.breadcrumbList.length > 0) {
        return this.$store.state.breadcrumbList;
      } else {
        return JSON.parse(window.sessionStorage.getItem("breadcrumbList"));
      }
    },
    categoryType() {
      return this.$route.query.type;
    }
  },
  components: {
    BroadsideMenu,
    ArticleList,
    Article
  },
  created() {
    setTimeout(() => {
      this.getMenuList();
      if (this.$route.query.articleId) {
        this.getArticle();
      } else {
        this.getArticleList(this.articleCurrent);
      }
    }, 300);
  },
  watch: {
    $route() {
      setTimeout(() => {
        this.getMenuList();
        if (this.$route.query.articleId) {
          this.getArticle();
        } else {
          this.getArticleList(this.articleCurrent);
        }
      }, 300);
    }
  },
  methods: {
    clickBreadcrumbItem(link, item, index) {
      if (link !== "home") {
        this.$store.commit("eidtBreadcrumb", item.id);
        if (this.breadcrumbList.length === 2 && index === 1) {
          this.$router.push({
            name: link,
            query: {
              type: item.categoryType,
              selectMenuId: item.parentId,
              selectMoreId: item.id
            }
          });
        } else if (index !== this.breadcrumbList.length) {
          this.$router.push({
            name: link,
            query: { type: item.categoryType, selectMenuId: item.id }
          });
        }
      } else {
        let id = 2;
        this.$http
          .get("/open/cms/category?filter=name||eq||网站首页")
          .then(res => {
            if (res.data.data[0]) {
              id = res.data.data[0].id;
            }
          });
        this.$router.push({ name: "home", query: { selectMenuId: id } });
      }
    },
    async getMenuList() {
      let parentId = null;
      parentId = this.$route.query.selectThreeId
        ? this.$route.query.selectMoreId
        : this.$route.query.selectMenuId;
      await this.$http
        .get(
          `/open/cms/category?page=1&filter=parentId||eq||${parentId}&sort=rank,ASC`
        )
        .then(res => {
          if (
            parentId === this.$route.query.selectMoreId ||
            parentId === this.$route.query.selectMenuId
          ) {
            if (res.data.data.length > 0) {
              this.menuList = res.data.data;
            } else {
              this.menuList = JSON.parse(
                window.sessionStorage.getItem("menuList")
              );
            }
          } else {
            this.menuList = res.data.data;
          }
          window.sessionStorage.setItem(
            "menuList",
            JSON.stringify(this.menuList)
          );
        });
    },
    getArticle() {
      this.isLoading = true;
      this.articleDetail = null;
      this.articleList = [];
      this.$http
        .get(`/open/cms/article/${this.$route.query.articleId}`)
        .then(res => {
          this.articleDetail = res.data.data;
          if (this.articleDetail.publishedAt) {
            this.articleDetail.publishedAt = dayjs(
              new Date(this.articleDetail.publishedAt)
            ).format("YYYY-MM-DD");
            this.isLoading = false;
          }
        });
    },
    getArticleList(index) {
      this.isLoading = true;
      this.articleList = [];
      this.articleDetail = null;
      let getArticleId = null;
      if (this.$route.query.selectThreeId) {
        getArticleId = this.$route.query.selectThreeId;
      } else {
        getArticleId = this.$route.query.selectMoreId
          ? this.$route.query.selectMoreId
          : this.$route.query.selectMenuId;
      }
      this.$http
        .get(
          `/open/cms/article?page=${index}&filter=categoryId||eq||${getArticleId}`
        )
        .then(res => {
          this.$route.query.type === "list"
            ? (this.articleList = res.data.data)
            : (this.articleDetail = res.data.data[0]);
          if (this.$route.query.type === "article") {
            if (this.articleDetail.publishedAt) {
              this.articleDetail.publishedAt = dayjs(
                new Date(this.articleDetail.publishedAt)
              ).format("YYYY-MM-DD");
            }
          }
          this.articleTotal = res.data.meta.total;
          this.isLoading = false;
        });
    },
    changePage(index) {
      this.getArticleList(index);
    }
  }
};
</script>

<style lang="scss" scoped>
.article {
  min-height: 70%;
}
.header {
  width: 1200px;
  height: 40px;
  background: white;
  line-height: 40px;
  padding: 0 16px;
  &-item {
    float: left;
  }
}
.active {
  cursor: pointer;
  &:hover {
    color: #ff9240;
  }
}
.content {
  margin-top: 16px;
  &-text {
    font-size: 30px;
    color: #cccccc;
    text-align: center;
    margin-top: 100px;
  }
}
.left {
  width: 275px;
  background: #fff;
  padding: 4px;
}
.right {
  display: inline-block;
  width: 900px;
  min-height: 421px;
  padding: 24px;
  background: #fff;
  margin-left: 16px;
  vertical-align: top;
}
.active-right {
  width: 100%;
  margin-left: 0px;
}
.footer {
  display: flex;
  justify-content: flex-end;
  margin: 20px 12px 0 0;
}
</style>